import { FETCH_ACTION_BEGIN, FETCH_ACTION_SUCCESS, FETCH_ACTION_FAIL, SUCCESS, ERROR } from './types';

import Helper from '../components/Helper';

//const evtUrl = Helper.actionUrl();
export const fetchAction = (formData, actionUrl) => dispatch => {
//     dispatch({
//         type: FETCH_ACTION_BEGIN,
//     })
//     var postURL = `${evtUrl}${actionUrl}`;
//     fetch(postURL , {
//         credentials: 'include',
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/x-www-form-urlencoded'
//         },
//         body: formData
//     })
//     .then(res => res.json())
//     .then(res => {
//         dispatch({
//             type: FETCH_ACTION_SUCCESS,
//             payload: res
//         })
//    /*      if (res.result == SUCCESS) {
//             dispatch({
//                 type: FETCH_ACTION_SUCCESS,
//                 payload: res
//             })
//         } else {
//             dispatch({
//                 type: FETCH_ACTION_FAIL,
//                 payload: { error }
//             })
//         } */
//     })
//     .catch(error => {
//         dispatch({
//             type: FETCH_ACTION_FAIL,
//             payload: { error }
//         })
//         throw error
//     })
const dispatcher=dispatch;
Helper.customFetchApi(actionUrl,formData,false,FETCH_ACTION_BEGIN,FETCH_ACTION_SUCCESS,FETCH_ACTION_FAIL,dispatcher);
}